<template>
	<b-modal id="mustering-report-modal" ref="musteringModalRef" title="Emergency Mustering Report" class="" :class="" centered size="lg">

		<div class="table-wrapper">
			<table class="table table-striped table-hover">
				<thead>
				<tr>
					<th>#</th>
					<th>Time Initiated</th>
					<th>Time Completed</th>
					<th>Duration</th>
				</tr>
				</thead>
				<tbody>
				<tr v-for="(item, key, index) in $finder.all({type: 'muster', status: 'end'}, log)">
					<td>{{index+1}}</td>
					<td>{{$datetime.datetime(item.time, item.day)}}</td>
					<td>{{$datetime.datetime(item.stopwatch + item.time, item.day)}}</td>
					<!--<td>{{ moment.utc((item.end - item.time)*1000).format('HH:mm:ss') }}</td>-->
					<td>{{ moment.utc((item.stopwatch)*1000).format('HH:mm:ss') }}</td>
				</tr>
				</tbody>
			</table>
		</div>

		<div slot="modal-footer">
			<b-btn type="button" class="btn btn-dark pl-4 pr-4" @click="$refs.musteringModalRef.hide()">Close</b-btn>
		</div>

	</b-modal>
</template>
<script>
	export default {
		name: 'MusteringReport',
		computed: {
			log() { return this.$store.state.log },
		}
	}
</script>